import React from "react";

function clippers() {
  return (
    <div className="h-12">
      <svg width="45.923" height="253.092" viewBox="10 1000 400 120 ">
        <g data-name="los angeles clippers" transform="translate(.007)">
          <path
            d="M5.431,91.712A16.535,16.535,0,0,0,0,104.543V198.8a16.887,16.887,0,0,0,5.429,13,16.569,16.569,0,0,0,13.325,4.113c8.554-.658,16.944-1.316,25.334-1.974V196.172c-8.39.494-16.78.987-25.334,1.481V105.695c8.554.494,16.944.987,25.334,1.481V89.244c-8.39-.658-16.78-1.316-25.334-1.974A16.582,16.582,0,0,0,5.431,91.712Z"
            data-name="Path 3933"
            transform="translate(0 32.325)"
          />
          <path
            d="M53.794,90.116c-6.251-.494-12.5-.823-18.754-1.316V213.166c13.654-.987,27.472-1.81,41.126-2.468V193.59c-7.4.329-14.97.493-22.373.823Z"
            data-name="Path 3934"
            transform="translate(12.998 32.934)"
          />
          <path
            d="M67.68,209.822c6.416-.329,13-.658,19.247-.823V91.543c-6.251-.165-12.831-.494-19.247-.823Z"
            data-name="Path 3935"
            transform="translate(25.104 33.646)"
          />
          <path
            d="M116.394,141.779h-13V108.713c4.442,0,8.554,0,13,.165Zm0-49.516C105.7,92.1,95.173,91.769,84.48,91.44V208.568c6.416-.329,12.667-.494,18.918-.658v-49.68h13a19.611,19.611,0,0,0,13.16-4.771,14.642,14.642,0,0,0,5.758-11.515v-32.9a14.641,14.641,0,0,0-5.758-11.515A19.253,19.253,0,0,0,116.394,92.263Z"
            data-name="Path 3936"
            transform="translate(31.334 33.913)"
          />
          <path
            d="M215.478,107.908c4.277-.165,8.39-.329,12.831-.658V141.8c-4.277,0-8.554.165-12.831.165Zm25.992,46.226A15.981,15.981,0,0,0,246.9,141.8v-35.2a15.308,15.308,0,0,0-5.429-12.009,17.367,17.367,0,0,0-13.325-4.442q-15.793.987-31.585,1.481V209.407c6.251.164,12.5.494,18.918.823V159.562c5.1,16.944,10.364,34.053,15.628,51.49,6.251.494,12.5.658,18.754,1.152-5.429-18.26-11.022-36.191-16.451-53.793a16.083,16.083,0,0,0,8.061-4.277Z"
            data-name="Path 3937"
            transform="translate(72.902 33.402)"
          />
          <path
            d="M155.949,141.468H143.118V108.731h12.831Zm0-49.187c-10.528.165-21.221.165-31.75,0V207.106c6.251-.165,12.667-.165,18.918-.165V157.754h12.831a19.617,19.617,0,0,0,13.325-4.606,15.628,15.628,0,0,0,5.593-11.844V108.4a14.7,14.7,0,0,0-5.593-11.515,20.468,20.468,0,0,0-13.325-4.606Z"
            data-name="Path 3938"
            transform="translate(46.066 34.223)"
          />
          <path
            d="M163.92,207.625c13.818.165,27.637.658,41.291,1.152V192c-7.4-.165-14.97-.494-22.373-.494v-33.23c4.442,0,12.009,0,16.122.164v-16.78c-4.277,0-11.844,0-16.122.165v-33.23c7.567-.165,14.97-.329,22.373-.494V91.32c-13.818.494-27.637.987-41.291,1.152Z"
            data-name="Path 3939"
            transform="translate(60.797 33.868)"
          />
          <path
            d="M288.861,123.3V104.381a15.8,15.8,0,0,0-5.593-12.667,16.049,16.049,0,0,0-13.16-4.442c-5.264.329-10.528.823-15.793,1.152a20.326,20.326,0,0,0-13.325,6.251,17.544,17.544,0,0,0-5.429,12.831v35.2a16.325,16.325,0,0,0,5.429,12.5,18.636,18.636,0,0,0,13.325,5.264c5.264.165,10.528.165,15.793.329v36.685c-5.264-.329-10.528-.494-15.793-.823v-18.1l-18.754-.494v17.6a17.544,17.544,0,0,0,5.429,12.831,19.415,19.415,0,0,0,13.325,6.087c5.264.494,10.528.823,15.793,1.316a17.1,17.1,0,0,0,13.16-4.277,16.244,16.244,0,0,0,5.593-13V160.971a17.647,17.647,0,0,0-5.593-13.325,17.245,17.245,0,0,0-13.16-5.264c-5.264,0-10.528,0-15.793.164V106.519l15.793-.987v18.425C276.358,123.792,282.609,123.463,288.861,123.3Z"
            data-name="Path 3940"
            transform="translate(87.365 32.323)"
          />
          <path
            fill="#bec0c2"
            d="M19.553,88.9c7.4.658,15.134,1.316,23.031,1.81v-.658C34.523,89.4,26.462,88.9,18.4,88.246a6.749,6.749,0,0,0-1.81-.165A15.036,15.036,0,0,0,5.9,92.194,15.751,15.751,0,0,0,.963,104.2v94.261a15.507,15.507,0,0,0,3.29,10.2,16.581,16.581,0,0,1-2.468-9.048V105.355a15.668,15.668,0,0,1,5.1-12.173A14.511,14.511,0,0,1,17.579,88.9Z"
            data-name="Path 3941"
            transform="translate(.355 32.665)"
          />
          <path
            fill="#bec0c2"
            d="M52.166,91.69v-.823c-5.429-.165-10.857-.658-16.286-.987V211.449l.823-.164V90.7C41.8,90.867,46.9,91.2,52.166,91.69Z"
            data-name="Path 3942"
            transform="translate(13.31 33.334)"
          />
          <path
            fill="#bec0c2"
            d="M85.375,93.161v-.823c-5.429-.165-11.186-.494-16.615-.658V207.985h.823V92.5C74.682,92.667,79.946,93,85.375,93.161Z"
            data-name="Path 3943"
            transform="translate(25.504 34.002)"
          />
          <path
            fill="#bec0c2"
            d="M117.025,94.09a19.356,19.356,0,0,1,10.2,2.8A20.819,20.819,0,0,0,115.873,93.1c-10.035-.165-20.4-.494-30.433-.823v114.5h.823V93.267h.165C96.462,93.6,106.99,93.925,117.025,94.09Z"
            data-name="Path 3944"
            transform="translate(31.69 34.224)"
          />
          <path
            fill="#bec0c2"
            d="M230.257,91.786a16.581,16.581,0,0,1,9.048,2.468,15.062,15.062,0,0,0-10.035-3.29h-1.316c-9.87.494-20.234.987-30.433,1.481V207.927h.823V93.267c10.364-.329,20.728-.823,30.762-1.316A2.8,2.8,0,0,1,230.257,91.786Z"
            data-name="Path 3945"
            transform="translate(73.258 33.731)"
          />
          <path
            fill="#bec0c2"
            d="M142.927,94.065h13.983a18.94,18.94,0,0,1,10.2,2.8,17.7,17.7,0,0,0-11.351-3.619h-30.6V205.435h.823V94.065Z"
            data-name="Path 3946"
            transform="translate(46.422 34.578)"
          />
          <path
            fill="#bec0c2"
            d="M203.539,92.28c-12.831.494-25.663.823-38.659.987V206.118h.823V94.09c12.5-.165,25.334-.494,37.836-.987Z"
            data-name="Path 3947"
            transform="translate(61.153 34.224)"
          />
          <path
            fill="#bec0c2"
            d="M270.991,88.9h1.645a15.353,15.353,0,0,1,8.225,2.139,15.186,15.186,0,0,0-9.377-2.961h-1.645c-5.264.494-10.528.823-15.793,1.316a18.564,18.564,0,0,0-12.5,5.758A16.4,16.4,0,0,0,236.28,107v35.369a15.256,15.256,0,0,0,3.29,9.541,14.937,14.937,0,0,1-2.468-8.554v-35.2a15.874,15.874,0,0,1,5.264-12.009,18.743,18.743,0,0,1,12.667-5.922C260.462,89.891,265.726,89.4,270.991,88.9Z"
            data-name="Path 3948"
            transform="translate(87.633 32.666)"
          />
          <path
            fill="#006bb6"
            d="M.12,200.8a1515.376,1515.376,0,0,1,376.223,0v-6.58a1635.028,1635.028,0,0,0-376.223,0Z"
            data-name="Path 3949"
            transform="translate(.047 68.004)"
          />
          <path
            fill="#ed174c"
            d="M33.12,215.167a566.784,566.784,0,0,1,285.416,0V209.08a578.137,578.137,0,0,0-285.416,0Z"
            data-name="Path 3950"
            transform="translate(12.286 70.908)"
          />
          <path
            fill="#006bb6"
            d="M150.807,81.866A1486.692,1486.692,0,0,1,.12,70.68v6.58c53.135,6.251,106.6,9.706,160.228,10.693a105.678,105.678,0,0,1-9.541-6.087Z"
            data-name="Path 3951"
            transform="translate(.047 26.214)"
          />
          <path
            fill="#006bb6"
            d="M167.1,81.866a57.518,57.518,0,0,1-9.541,5.922c53.464-.987,107.093-4.442,160.228-10.528V70.68A1486.847,1486.847,0,0,1,167.1,81.866Z"
            data-name="Path 3952"
            transform="translate(58.438 26.214)"
          />
          <path
            fill="#ed174c"
            d="M126.065,74.037A584.3,584.3,0,0,1,33.12,58.08v6.087a576.773,576.773,0,0,0,98.21,16.121A62.313,62.313,0,0,1,126.065,74.037Z"
            data-name="Path 3953"
            transform="translate(12.286 21.541)"
          />
          <path
            fill="#ed174c"
            d="M175.109,74.037a64.2,64.2,0,0,1-5.429,6.251,608.285,608.285,0,0,0,98.21-16.122V58.08a582.325,582.325,0,0,1-92.781,15.957Z"
            data-name="Path 3954"
            transform="translate(62.933 21.541)"
          />
          <path
            fill="#fff"
            d="M94.92,58.07a57.988,57.988,0,1,1,58.07,57.906A57.988,57.988,0,0,1,94.92,58.07Z"
            data-name="Path 3955"
            transform="translate(35.206)"
          />
          <path
            d="M194.939,90.313a51.926,51.926,0,0,1-10.857-29.775h21.879a54.079,54.079,0,0,1-11.022,29.775Zm-39.481,20.563V95.742h-4.935v15.134A52.84,52.84,0,0,1,114.5,94.261,57.133,57.133,0,0,0,127.163,60.7V55.6A56.727,56.727,0,0,0,114.5,22.044a52.318,52.318,0,0,1,36.027-16.78V20.4h4.935V5.264a51.825,51.825,0,0,1,36.027,16.615,57.134,57.134,0,0,0-12.667,33.559v5.1A56.728,56.728,0,0,0,191.484,94.1a52,52,0,0,1-36.027,16.78ZM111.041,90.313a51.926,51.926,0,0,1-10.857-29.775h21.879A52.855,52.855,0,0,1,111.041,90.313Zm0-64.486A53.112,53.112,0,0,1,121.9,55.6H100.02a54.549,54.549,0,0,1,11.022-29.775Zm83.9,0A53.112,53.112,0,0,1,205.8,55.6H183.917a52.113,52.113,0,0,1,11.022-29.775ZM152.99,0A57.988,57.988,0,1,0,210.9,58.07,57.988,57.988,0,0,0,152.99,0Z"
            data-name="Path 3956"
            transform="translate(35.206)"
          />
          <path
            fill="#ed174c"
            d="M127.8,24.6V72.965h25.992v-6.58H134.874V24.6Z"
            data-name="Path 3957"
            transform="translate(47.401 9.124)"
          />
          <path
            fill="#006bb6"
            d="M164.869,43.022V23.117c0-2.961-1.316-4.277-4.113-4.277h-35.2c-2.961,0-4.113,1.316-4.113,4.277v56.1c0,2.961,1.152,4.113,4.113,4.113h35.2c2.961,0,4.113-1.152,4.113-4.113V59.144H157.8v18.1H128.349V24.927H157.8v18.1Z"
            data-name="Path 3958"
            transform="translate(45.042 6.987)"
          />
          <path
            fill="#ed174c"
            d="M144.479,45.492h-3.29V31.345h3.29Zm6.909,19.083V24.6h-16.78l-.329,39.975h6.745l.165-12.5h3.29v12.5Z"
            data-name="Path 3959"
            transform="translate(49.804 9.124)"
          />
        </g>
      </svg>
    </div>
  );
}

export default clippers;
